/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractTemplateDetails_stateTypes$ref: FragmentReference;
declare export opaque type ContractTemplateDetails_stateTypes$fragmentType: ContractTemplateDetails_stateTypes$ref;
export type ContractTemplateDetails_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: ContractTemplateDetails_stateTypes$ref,
|};
export type ContractTemplateDetails_stateTypes$data = ContractTemplateDetails_stateTypes;
export type ContractTemplateDetails_stateTypes$key = {
  +$data?: ContractTemplateDetails_stateTypes$data,
  +$fragmentRefs: ContractTemplateDetails_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContractTemplateDetails_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '027ee76de62c310e0c81151867406f07';
module.exports = node;
